/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useContext } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { forbidExtraProps, deepClone } from "utils";
import { LayoutContext } from "App/common/hoc/Layout";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import Loader from "App/common/ui/Loader";
import { BACKUP_SETTINGS } from "App/componentsConfig";
import ServerDown from "App/common/ui/ServerDown";
import {
  fetchBackupSettingsStart,
  cacheBackupSettings,
  cleanCache,
  removeClientFromList,
  closeRefresh,
  clearBackupSettings,
  hideNotification
} from "store/actions";
import { VALIDATION } from "consts";

function BackupSettings(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const { sPopupState, sPopupMethods } = useContext(SPopupContext);
  const [currentPanel, setCurrentPanel] = useState({
    name: "summary",
    type: ""
  });
  let settings = null;

  const switchPanelHandler = useCallback((name, type) => {
    setCurrentPanel({ name: name, type: type });
    props.hideNotification("slidingPopup");
  }, []);

  useEffect(() => {
    props.fetchBackupSettingsStart(lState.slidingPopup.params.clientUUID);
    props.hideNotification("slidingPopup");

    return () => {
      props.cleanCache("backupSettings");
      props.clearBackupSettings();
    };
  }, []);

  useEffect(() => {
    let timer = null;
    if (props.notification && props.notification.slidingPopup) {
      sPopupMethods.showNotify(props.notification.slidingPopup);
      if (
        (sPopupState.currentTab === "enableMachine" &&
          props.notification.slidingPopup.status !== "warning") ||
        (sPopupState.popup.alertName === "removeMachine" &&
          props.notification.slidingPopup.status === "success")
      )
        timer = setTimeout(() => {
          lMethods.closeSlidingPopup();
          clearTimeout(timer);
        }, 1000);
      // else if (
      //   sPopupState.currentTab === "enableMachine" &&
      //   props.notification.slidingPopup.status !== "warning"
      // ) {
      //   lMethods.changeSlidingPopupAlert("settings", "backup");
      //   sPopupMethods.switchTab("backup");
      //   props.cleanCache("backupSettings");
      //   props.fetchBackupSettingsStart(lState.slidingPopup.params.clientUUID);
      // }
    } else {
      if (sPopupState.notify.show) {
        if (
          sPopupState.notify.params.msg !==
            VALIDATION.backupSettings.source.emptyVolumes &&
          sPopupState.notify.params.msg !==
            VALIDATION.backupSettings.schedule.emptyWeekdays &&
          sPopupState.notify.params.msg !==
            VALIDATION.backupSettings.schedule.emptyMonths &&
          sPopupState.notify.params.msg !==
            VALIDATION.backupSettings.schedule.validDates
        )
          sPopupMethods.closeNotify();
      }
    }

    return () => {
      clearTimeout(timer);
    };
  }, [props.notification, currentPanel, sPopupState.popup]);

  //Refresh for settings
  useEffect(() => {
    if (sPopupState.refresh.show) {
      sPopupMethods.closeRefresh();
      props.closeRefresh();
    } else if (props.settings.changed) {
      if (!props.settings.preChanged) {
        sPopupMethods.showRefresh(() => {
          switchPanelHandler("summary");
          props.cleanCache("backupSettings");
          props.fetchBackupSettingsStart(lState.slidingPopup.params.clientUUID);
        });
        sPopupMethods.closePopup();
      } else props.closeRefresh();
    }
  }, [props.settings.changed]);

  //Close notification on changes in panel.
  useEffect(() => {
    if (sPopupState.notify.show) sPopupMethods.closeNotify();
  }, [currentPanel]);

  if (props.settings.loading) settings = <Loader />;
  else if (props.settings.failed)
    settings = (
      <ServerDown
        data={{
          status: props.settings.failed.status,
          msg: props.settings.failed.msg
        }}
      />
    );
  else {
    if (!props.cachedSettings)
      setTimeout(() => props.cacheBackupSettings(deepClone(props.settings)), 0);
    settings = React.createElement(
      BACKUP_SETTINGS[currentPanel.name].component,
      {
        switchPanel: switchPanelHandler,
        currentPanel
      }
    );
  }

  return <div className="slider_content_backup">{settings}</div>;
}

BackupSettings.propTypes = forbidExtraProps(
  {
    settings: PropTypes.object,
    cachedSettings: PropTypes.object,
    notification: PropTypes.shape({
      status: PropTypes.oneOf([0, 1]),
      msg: PropTypes.string
    }),
    refresh: PropTypes.shape({
      show: PropTypes.bool,
      fetch: PropTypes.object
    })
  },
  [
    "fetchBackupSettingsStart",
    "cacheBackupSettings",
    "cleanCache",
    "removeClientFromList",
    "closeRefresh",
    "clearBackupSettings",
    "hideNotification"
  ]
);

function mapStateToProps(state) {
  return {
    settings: state.backupSettings,
    cachedSettings: state.common.backupSettings,
    notification: state.common.notification,
    refresh: state.common.refresh
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchBackupSettingsStart,
      cacheBackupSettings,
      cleanCache,
      removeClientFromList,
      closeRefresh,
      clearBackupSettings,
      hideNotification
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BackupSettings);
